<template>
	<div>
		<div v-if="!emzameContractAuthorizationItem || !emzameContractAuthorizationItem.contract">
			<div class="red--text text-ecnter mb-2">لطفا جهت آماده سازی امضای قرارداد، بر روی دکمه "ارسال به سامانه امضامی" کلیک نمایید .</div>
			<div class="text-center">
				<div class="text-center mb-2" v-if="['admin', 'agent'].includes(area)">
					<v-btn small outlined color="secondary" @click="showManualDialog()" width="200" class="">
						ثبت اطلاعات تکمیلی
					</v-btn>
				</div>
				<div class="text-center mb-2">
					<v-btn small outlined color="secondary" @click="createAndSend()" width="200" :loading="sendLoading">
						ارسال به سامانه امضامی
					</v-btn>
				</div>
				<div class="text-center">
					<v-btn small outlined color="secondary" @click="contractDialog = true" width="200">
						مشاهده قرارداد
					</v-btn>
				</div>
			</div>
		</div>
		<div v-if="emzameContractAuthorizationItem && emzameContractAuthorizationItem.contract">
			<v-row>
				<v-col cols="12" md="1" class="d-flex align-start pt-0">
					<v-badge :content="emzameContractAuthorizationItem.contract.status === 'accept' ? '✓' : ''" location="top end" offset-x="50" offset-y="15" :color="emzameContractAuthorizationItem.contract.status === 'accept' ? 'success' : 'transparent'">
						<v-btn outlined :color="emzameContractAuthorizationItem.contract.status === 'accept' ? 'success' : 'grey'" :icon="true">
							<v-icon v-if="emzameContractAuthorizationItem.contract.status === 'accept'">mdi-fingerprint</v-icon>
							<v-icon v-else>mdi-fingerprint-off</v-icon>
						</v-btn>
					</v-badge>
				</v-col>
				<v-col cols="12" md="8" class="pr-0">
					<div class="text-right pr-2">
						{{ emzameContractAuthorizationItem.contract.status_str }}
						<div class="grey-text">
							<small>شماره قرارداد: {{ emzameContractAuthorizationItem.contract._id }}</small>
							<small class="mr-3">تاریخ امضا: &lrm;{{ emzameContractAuthorizationItem.contract.changedDate_persian.date }} {{ emzameContractAuthorizationItem.contract.changedDate_persian.time }}</small>
						</div>
					</div>
					<div class="mt-5" v-if="emzameContractAuthorizationItem.contract.collaborator.length && false">
						<div class="d-flex" v-for="collaborator in emzameContractAuthorizationItem.contract.collaborator" :key="collaborator.nationalCode">
							<div class="d-flex align-start ml-2">
								<v-avatar class="" size="30" :color="statusIconColor(collaborator.status) + ' lighten-5'">
									<v-icon small :color="statusIconColor(collaborator.status)">
										{{ statusIcon(collaborator.status) }}
									</v-icon>
								</v-avatar>
							</div>

							<div class="text-right ml-3">
								<div class="grey--text text--darken-2"><small>کد ملی:</small></div>
								<div class="grey--text"><small>{{ collaborator.nationalCode }}</small></div>
							</div>

							<div class="text-right ml-3" style="min-width:115px">
								<div class="grey--text text--darken-2"><small>نام و نام خانوادگی:</small></div>
								<div class="grey--text"><small>{{ collaborator.fullName }}</small></div>
							</div>

							<div class="text-right ml-3">
								<div class="grey--text text--darken-2"><small class="grey--text text--darken-3">وضعیت امضا‍:</small></div>
								<div class="grey--text"><small class="grey--text ml-3">{{ collaborator.status_str }}</small></div>
							</div>
						</div>
					</div>
				</v-col>
				<v-col cols="12" md="3" class="d-flex flex-column">
					<v-btn small outlined block color="secondary" @click="fetchLatestStaus()" :loading="fetchLatestStausLoading" class="mb-2">
						دریافت آخرین وضعیت
					</v-btn>
					<v-btn small outlined block color="secondary" @click="contractDialog = true" class="mb-2">
						مشاهده قرارداد
					</v-btn>
					<v-btn v-if="['expired', 'reject'].includes(emzameContractAuthorizationItem.contract.status)" small outlined block color="secondary" @click="createAndSend()" :loading="sendLoading" class="mb-2">
						ارسال مجدد به امضامی
					</v-btn>
				</v-col>
			</v-row>
			<div class="mt-2 text-justify contract" v-if="emzameContractAuthorizationItem.tag" v-html="emzameContractAuthorizationItem.tag">

			</div>
		</div>

		<v-dialog v-model="contractDialog" max-width="1600px">
			<v-card color="#eee">
				<v-card-title>
					<div>
						<span class="headline">اطلاعات قرارداد</span>
					</div>
					<v-spacer />
					<v-btn @click="contractDialog = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text>
					<div style="overflow-x: auto;padding: 5px 0;" class="d-flex justify-center">
						<div id="printHtmlContract" v-if="auth" style="border: 1px solid #ccc;background-color: white;padding: 10px;color: #000;width: 190mm;" class="my-5">
							<div v-if="contractDialog" v-html="emzameContractAuthorizationItem.comment">
							</div>
						</div>
					</div>
					<div>
						<v-row class="justify-center">
							<v-col cols="12" md="4" xl="4">
								<v-btn block small color="secondary" text @click="print()">
									<v-icon left>mdi-printer-outline</v-icon>
									چاپ قرارداد
								</v-btn>
							</v-col>
						</v-row>
					</div>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="manualDialog" max-width="500px" scrollable>
			<v-card>
				<v-card-title>
					<div>
						<span class="headline">اطلاعات دستی قرارداد</span>
					</div>
					<v-spacer />
					<v-btn @click="manualDialog = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text>
					<div v-if="manualFields.length" class="mt-5">
						<v-text-field v-for="(field, index) in manualFields" :key="field.id || index" v-model="field.value" :label="field.label" dense outlined />
					</div>
					<div v-else class="text-center grey--text">
						موردی برای نمایش وجود ندارد.
					</div>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer />
					<v-btn text @click="manualDialog = false">
						بستن
					</v-btn>
					<v-btn color="secondary" :loading="submitManualTagsLoading" @click="submitManualTags">به روز رسانی
						متن قرارداد</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="alertDialog" max-width="450px" scrollable>
			<v-card>
				<v-card-title>
					<div>
						<span class="headline">توجه</span>
					</div>
					<v-spacer />
					<v-btn @click="alertDialog = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text>
					<div class="text-justify red--text">
						کاربر گرامی، درخواست امضای قرارداد شما به سامانه امضامی ارسال شد. هم اکنون پیامک حاوی
						لینک امضا از سامانه امضامی برای شما ارسال خواهد شد. لطفا از طریق لینک ارسالی اقدام به
						امضای قرارداد نمایید.
					</div>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer />
					<v-btn color="primary" @click="alertDialog = false">
						متوجه شدم
					</v-btn>
					<v-spacer />
				</v-card-actions>
			</v-card>
		</v-dialog>

	</div>
</template>

<script>
	import api from '@/util/app-api'
	import { get } from 'vuex-pathify'
	import { emptyId } from '@/util/emptyId'
	import toast from '@/util/toast'
	import { auth } from '@/store/modules'
	import { cloneDeep } from 'lodash'
	import printJS from 'print-js'

	export default {
		name: 'DigitalSignEmzame',
		props: {
			auth: { type: Object, default: null },
			emzameContractAuthorizationItem: { type: Object, default: null },
			area: { type: String, default: 'member' },
			memberId: { type: Number },
		},
		data() {
			return {
				submitManualTagsLoading: false,
				fetchLatestStausLoading: false,
				manualDialog: false,
				contractDialog: false,
				manualFields: [],
				alertDialog: false,
				sendLoading: false,
			}
		},
		components: {
		},
		computed: {

		},
		mounted() {

		},
		methods: {
			extractManualFields(description) {
				const fields = []
				if (!description) {
					this.manualFields = fields
					return
				}
				const regex = /\{manual:"([^"]+)"\}/g
				const prevFields = this.manualFields || []
				let match
				while ((match = regex.exec(description)) !== null) {
					const label = match[1]
					const index = fields.length
					fields.push({
						id: `${match.index}-${label}-${index}`,
						label,
						value: prevFields[index]?.value || ''
					})
				}
				this.manualFields = fields
			},
			async submitManualTags() {
				this.submitManualTagsLoading = true
				let id = this.emzameContractAuthorizationItem?.id
				try {
					id = await this.createIfRequired()
					this.$emit('updated')
				} catch (error) {
					this.submitManualTagsLoading = false
					toast.error(error.message || 'خطا در ایجاد امضا')
					return
				}
				const manualFieldsObj = this.manualFields.reduce((acc, field) => {
					acc[field.label] = field.value
					return acc
				}, {})
				api.post(`${this.area}/EmzameContractAuthorizationItem/UpdateContractDescription/`, { manualFields: manualFieldsObj, emzameContractAuthorizationItemId: id })
					.then(response => {
						this.manualDialog = false
						toast.success('اطلاعات قرارداد با موفقیت ثبت شد.')
						this.$emit('updated')
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(() => {
						this.submitManualTagsLoading = false
					})
			},
			statusIconColor(status) {
				switch (status) {
					case 'accept':
						return 'green'
					case 'reject':
						return 'red'
					case 'readyForSign':
						return 'orange'
					case 'waitForOtherSigners':
						return 'orange'
					case 'expired':
						return 'grey'
					default:
						return 'orange'
				}
			},
			statusIcon(status) {
				switch (status) {
					case 'accept':
						return 'mdi-check'
					case 'reject':
						return 'mdi-close'
					case 'readyForSign':
						return 'mdi-timer-sand'
					case 'waitForOtherSigners':
						return 'mdi-timer-sand'
					case 'expired':
						return 'mdi-clock-alert-outline'
					default:
						return 'mdi-timer-sand'
				}
			},
			createIfRequired() {
				if (this.emzameContractAuthorizationItem?.contract || this.emzameContractAuthorizationItem?.id)
					return this.emzameContractAuthorizationItem?.id
				let data = {
					authorizationItemId: this.auth.authorizationItem.id,
					userLoanRequestAuthorizationItemId: this.auth.id,
					userLoanId: null,
					user: { id: this.memberId }
				}
				return api.post(`${this.area}/EmzameContractAuthorizationItem/Create/`, data)
			},
			async createAndSend() {
				this.sendLoading = true
				let id = this.emzameContractAuthorizationItem?.id
				try {
					id = await this.createIfRequired()
					this.$emit('updated')
				} catch (error) {
					this.sendLoading = false
					toast.error(error.message || 'خطا در ایجاد امضا')
					return
				}
				api.post(`${this.area}/EmzameContractAuthorizationItem/SendContractToEmzame/${id}`, {})
					.then(response => {
						this.manualDialog = false
						toast.success('اطلاعات قرارداد با موفقیت ثبت شد.')
						this.$emit('updated')
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(() => {
						this.sendLoading = false
						this.submitManualTagsLoading = false
					})
			},
			fetchLatestStaus() {
				this.fetchLatestStausLoading = true
				api.post(`${this.area}/EmzameContractAuthorizationItem/GetContractFromEmzame/${this.emzameContractAuthorizationItem?.id}`, {})
					.then(response => {
						this.$emit('updated')
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(() => {
						this.fetchLatestStausLoading = false
					})
			},
			showManualDialog() {
				this.extractManualFields(this.auth.authorizationItem.description)
				this.manualDialog = true
			},
			print() {
				printJS({
					printable: 'printHtmlContract',
					type: 'html',
					scanStyles: false, // If true inline styles will be removed
					targetStyles: ['*'],
					style: `
										@font-face {
											font-family:'YekanP';
											src:url(/iranyekanweb.ttf) format('truetype'),
											url(/iranyekanweb.woff) format('woff-variations'),
											url(/iranyekanweb.woff) format('woff'),
											url(/iranyekanweb.woff2) format('woff2');
											font-display:fallback
										}
										#printHtmlContract {
											display: block !important;
											font-family: 'YekanP', sans-serif;
											direction: rtl;
										}
										#printHtmlContract .contract{
											display: block;
											font-size: 12px;
										}
									`
				})
			}
		}
	}
</script>
<style scoped>
	.contract b {
		font-weight: 900;
		border-bottom: 1px dotted blue;
		color: blue;
	}
</style>
